import React, { useState } from "react";
import { Actions as userActions } from "../../core/redux/ducks/user";
import { Dialog } from "@material-ui/core";
import { useFormik } from "formik";
import * as Yup from "yup";
import { SignupForm } from "./SignupForm";
import { ConfirmationForm } from "./ConfirmationForm";
import { useDispatch } from "react-redux";
import _ from "lodash";

const validationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  lastname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  email: Yup.string().email("Invalid email").required("Required"),
  password: Yup.string()
    .min(8, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Required"),
  company: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
  terms: Yup.boolean().required("Required"),
  // phone: Yup.date().required("Required"),
});

export function SignupModal({ modalOpen, closeModal }) {
  const [newUser, setNewUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      confirmPassword: "",
      firstname: "",
      lastname: "",
      company: "",
      terms: false,
    },
    onSubmit: async (values) => {
      setIsLoading(true);
      const user = {
        email: values.email,
        password: values.password,
        confirmPassword: values.confirmPassword,
        profile: {
          first_name: values.firstname,
          last_name: values.lastname,
          company: values.company,
        },
      };
      const newUser = await userActions.register(dispatch, user);
      if (!_.isEmpty(newUser)) {
        setNewUser(user);
      } else {
        closeModal();
      }
      setIsLoading(false);
    },
    validateOnChange: true,
    validationSchema,
  });
  return (
    <Dialog open={modalOpen} onClose={closeModal} fullWidth maxWidth="md">
      {!newUser ? (
        <SignupForm
          formik={formik}
          isLoading={isLoading}
          closeModal={closeModal}
        />
      ) : (
        <ConfirmationForm closeModal={closeModal} />
      )}
    </Dialog>
  );
}
